import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class CheckoutService {
    async getCartItems(storeId, variantIds) {
        const url = `/checkout/${storeId}`;
        const { data } = await request.get(url, {
            params: {
                productIds: variantIds.join(','),
            },
        });
        return data;
    }

    /** Orka web checkout — primary ledger Shopify (commerce_connector). */
    async getShopifyCartItems(shop, variantIds, serviceId) {
        const { data } = await request.get('/checkout/shopify/cart', {
            params: {
                shop,
                productIds: variantIds.join(','),
                service_id: serviceId || undefined,
            },
        });
        return data;
    }

    async createCart(payload) {
        const url = `/checkout/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, { payload });
        return data;
    }

    async sendOrderMessage(products, number, serviceId, paymentOption, upiId, order, checkoutPayload) {
        const url = `/checkout/message/${serviceId}`;
        const { data } = await request.post(url, { products, phoneNumber: number, paymentOption, upiId, order, checkoutPayload });
        return data;
    }

    async getOrderDetails(payload) {
        console.log('payload', payload);
        
        const url = `/order/details`;
        const { data } = await request.post(url, payload);
        return data;
    }

    async getVerticalCheckoutDetails(serviceId, checkoutSessionId) {
        const { data } = await request.get(`/checkout/${serviceId}/vertical/${checkoutSessionId}`);
        return data;
    }

    async createVerticalCheckoutPayment(serviceId, checkoutSessionId, customer) {
        const { data } = await request.post(
            `/checkout/${serviceId}/vertical/${checkoutSessionId}/payment`,
            { customer }
        );
        return data;
    }

    async confirmVerticalCheckoutPayment(serviceId, checkoutSessionId, payload) {
        const { data } = await request.post(
            `/checkout/${serviceId}/vertical/${checkoutSessionId}/confirm`,
            payload
        );
        return data;
    }
}
export default new CheckoutService();